import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeImg2024 from "../../Assets/home-photo-2024.jpg";
import homeImg2025 from "../../Assets/home-photo-2025.jpeg";
import homeImg2026 from "../../Assets/home-photo-2026.jpg";
import homeImg from "../../Assets/favrhoodapp.png";
import Tilt from "react-parallax-tilt";
import Slider from "react-slick";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { ShieldCheck, BookOpen, Users, HeartHandshake, Code2, Lightbulb } from "lucide-react";
import reviews from "../Testimonials/data";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function SliderArrow({ className, style, onClick, direction, ariaLabel }) {
  return (
    <button
      type="button"
      className={`home2-slider-arrow home2-slider-arrow--${direction} ${className || ""}`}
      style={style}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {direction === "prev" ? <FiChevronLeft aria-hidden="true" /> : <FiChevronRight aria-hidden="true" />}
    </button>
  );
}

function Home2() {
  const { t } = useTranslation();
  const [careerTestimonialIndex, setCareerTestimonialIndex] = React.useState(0);

  const handleFavrhoodClick = () => {
    window.open("https://www.favrhood.com/", "_blank", "noopener,noreferrer");
  };

  const careerTestimonials = React.useMemo(() => {
    if (!Array.isArray(reviews)) return [];
    return reviews.filter((item) => String(item?.job || "").includes("SYEP Intern"));
  }, []);

  const handleCareerTestimonialPrev = () => {
    setCareerTestimonialIndex((current) => {
      const total = careerTestimonials.length;
      if (total === 0) return 0;
      return (current - 1 + total) % total;
    });
  };

  const handleCareerTestimonialNext = () => {
    setCareerTestimonialIndex((current) => {
      const total = careerTestimonials.length;
      if (total === 0) return 0;
      return (current + 1) % total;
    });
  };

  const currentCareerTestimonial = careerTestimonials[careerTestimonialIndex];
  const currentCareerYear = String(currentCareerTestimonial?.job || "").match(/\b(20\d{2})\b/)?.[1] || t("homeV2.career.testimonial.currentCohort");

  const labImageSlides = [
    { src: homeImg2024, alt: t("homeV2.communityLab.slides.2024Alt"), caption: t("homeV2.communityLab.slides.2024Caption") },
    { src: homeImg2025, alt: t("homeV2.communityLab.slides.2025Alt"), caption: t("homeV2.communityLab.slides.2025Caption") },
    { src: homeImg2026, alt: t("homeV2.communityLab.slides.2026Alt"), caption: t("homeV2.communityLab.slides.2026Caption") },
  ];

  const journeySteps = t("homeV2.career.journey.steps", { returnObjects: true });
  const whyItems = t("homeV2.career.why.items", { returnObjects: true });
  const pillars = t("homeV2.favrhood.pillars.items", { returnObjects: true });
  const safeJourneySteps = Array.isArray(journeySteps) ? journeySteps : [];
  const safeWhyItems = typeof whyItems === "object" && whyItems !== null ? whyItems : {};
  const safePillars = typeof pillars === "object" && pillars !== null ? pillars : {};

  const labImageSliderSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3600,
    speed: 700,
    pauseOnHover: true,
    swipeToSlide: true,
    adaptiveHeight: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SliderArrow direction="next" ariaLabel={t("homeV2.a11y.nextImage")} />,
    prevArrow: <SliderArrow direction="prev" ariaLabel={t("homeV2.a11y.previousImage")} />,
  };

  return (
    <Container fluid className="home-about-section home-redesign" id="about">
      <Container>
        <section className="home-block" aria-label={t("homeV2.a11y.empoweringSection")}>
          <h2 className="home-block-title home-premium-mantra">{t("homeV2.mantra")}</h2>
        </section>

        <section className="home-block" aria-label={t("homeV2.a11y.communityLabSection")}>
          <Row className="align-items-center">
            <Col md={7} className="home-about-description">
              <p className="home-block-eyebrow">{t("homeV2.communityLab.eyebrow")}</p>
              <h2 className="home-block-title">{t("homeV2.communityLab.title")}</h2>
              <div className="policy-card home-about-copy-card">
                <p className="home-about-body home-about-body--card">
                  {t("homeV2.communityLab.body1")}
                </p>
                <p className="home-about-body home-about-body--secondary">
                  {t("homeV2.communityLab.body2")}
                </p>
                <p className="home-about-body home-about-body--secondary">
                  {t("homeV2.communityLab.body3")}
                </p>
              </div>
            </Col>
            <Col md={5} className="myAvtar">
              <div className="policy-card home2-avatar-card">
                <Tilt className="home2-avatar-tilt" tiltMaxAngleX={8} tiltMaxAngleY={8}>
                  <div className="home2-avatar-slider" aria-label={t("homeV2.a11y.communityLabHighlights")}>
                    <Slider {...labImageSliderSettings}>
                      {labImageSlides.map((image) => (
                        <div key={image.src} className="home2-avatar-slide">
                          <div className="home2-avatar-media">
                            <img src={image.src} className="img-fluid home2-avatar-img" alt={image.alt} loading="lazy" />
                          </div>
                          <div className="home2-avatar-caption">
                            {image.caption}
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </div>
                </Tilt>
              </div>
            </Col>
          </Row>
        </section>

        <section className="home-block" aria-label={t("homeV2.a11y.careerSection")}>
          <p className="home-block-eyebrow">{t("homeV2.career.eyebrow")}</p>
          <h2 className="home-block-title">{t("homeV2.career.title")}</h2>
          <div className="policy-card home-about-copy-card career-premium-card">
            <p className="home-about-body home-about-body--card">
              {t("homeV2.career.body1")}
            </p>
            <p className="home-about-body home-about-body--secondary">
              {t("homeV2.career.body2")}
            </p>
            <p className="home-about-body home-about-body--secondary">
              {t("homeV2.career.body3")}
            </p>
          </div>

          <h3 className="home-section-subtitle">{t("homeV2.career.journey.title")}</h3>
          <div className="student-journey-grid">
            {safeJourneySteps.map((item, idx) => (
              <div key={item.step} className="policy-card student-journey-card">
                <div className="journey-step-number">{idx + 1}</div>
                <h4 className="journey-step-title">{item.step}</h4>
                <p className="journey-step-description">{item.description}</p>
              </div>
            ))}
          </div>

          <div className="home-why-section-head">
            <h3 className="home-section-subtitle home-why-title">{t("homeV2.career.why.title")}</h3>
            <p className="home-why-lead">{t("homeV2.career.why.lead")}</p>
          </div>

          <div className="home-why-grid">
            {[
              {
                Icon: ShieldCheck,
                key: "twc",
              },
              {
                Icon: BookOpen,
                key: "projectLearning",
              },
              {
                Icon: Users,
                key: "smallClass",
              },
              {
                Icon: HeartHandshake,
                key: "communityCentered",
              },
              {
                Icon: Code2,
                key: "realApps",
              },
              {
                Icon: Lightbulb,
                key: "ethicalAi",
              },
            ].map(({ Icon, key }) => (
              <div key={key} className="home-why-card">
                <div className="home-why-icon-wrap" aria-hidden="true">
                  <Icon size={22} strokeWidth={2} />
                </div>
                <h4 className="home-why-label">{safeWhyItems[key]?.label}</h4>
                <p className="home-why-desc">{safeWhyItems[key]?.desc}</p>
              </div>
            ))}
          </div>
          <div className="home-inline-cta">
            <Button as={Link} to="/courses" className="custom-yellow-btn">{t("homeV2.career.exploreCta")}</Button>
          </div>

          {careerTestimonials.length > 0 ? (
            <div className="policy-card home-career-testimonial" aria-label={t("homeV2.career.testimonial.sectionLabel")}>
              <div className="home-career-testimonial-top">
                <div className="home-career-testimonial-labels">
                  <p className="home-career-testimonial-eyebrow">{t("homeV2.career.testimonial.eyebrow")}</p>
                  <p className="home-career-testimonial-kicker">{t("homeV2.career.testimonial.kicker")}</p>
                </div>
                <div className="home-career-testimonial-controls" aria-label={t("homeV2.career.testimonial.navigationLabel")}>
                  <button
                    type="button"
                    className="home-career-testimonial-btn"
                    onClick={handleCareerTestimonialPrev}
                    aria-label={t("homeV2.career.testimonial.prev")}
                  >
                    <FiChevronLeft />
                  </button>
                  <button
                    type="button"
                    className="home-career-testimonial-btn"
                    onClick={handleCareerTestimonialNext}
                    aria-label={t("homeV2.career.testimonial.next")}
                  >
                    <FiChevronRight />
                  </button>
                </div>
              </div>

              <div className="home-career-testimonial-person" aria-label={t("homeV2.career.testimonial.featuredIntern")}>
                <div className="home-career-testimonial-identity">
                  <span className="home-career-testimonial-name">
                    {currentCareerTestimonial.name}
                  </span>
                  <span className="home-career-testimonial-dot" aria-hidden="true" />
                  <span className="home-career-testimonial-year">{currentCareerYear}</span>
                </div>
                <span className="home-career-testimonial-role">{t("homeV2.career.testimonial.role")}</span>
              </div>

              <blockquote className="home-career-testimonial-quote">
                &ldquo;{currentCareerTestimonial.text}&rdquo;
              </blockquote>

              <div className="home-career-testimonial-progress" aria-hidden="true">
                {careerTestimonials.map((item, idx) => (
                  <span
                    key={item.id || `${item.name}-${idx}`}
                    className={`home-career-testimonial-progress-dot ${idx === careerTestimonialIndex ? "is-active" : ""}`}
                  />
                ))}
              </div>
            </div>
          ) : null}
        </section>

        <section className="home-block" aria-label={t("homeV2.a11y.favrhoodSection")}>
          <p className="home-block-eyebrow">{t("homeV2.favrhood.eyebrow")}</p>
          <h2 className="home-block-title">{t("homeV2.favrhood.title")}</h2>
          <div className="policy-card home-about-copy-card favrhood-premium-card">
            <p className="home-about-body home-about-body--card">
              {t("homeV2.favrhood.body1")}
            </p>
            <p className="home-about-body home-about-body--secondary">
              {t("homeV2.favrhood.body2")}
            </p>
            <p className="home-about-body home-about-body--secondary">
              {t("homeV2.favrhood.body3")}
            </p>
          </div>

          <h3 className="home-section-subtitle favrhood-pillars-title">{t("homeV2.favrhood.pillars.title")}</h3>
          <div className="foster-cards favrhood-pillars-grid" role="list" aria-label={t("homeV2.favrhood.pillars.ariaLabel")}>
            <Card className="foster-card favrhood-pillar-card favrhood-pillar-card--innovation" role="listitem">
              <Card.Body>
                <span className="favrhood-pillar-kicker">{safePillars.innovation?.kicker}</span>
                <Card.Title className="foster-card-title">{safePillars.innovation?.title}</Card.Title>
                <Card.Text className="foster-card-text">
                  {safePillars.innovation?.text}
                </Card.Text>
              </Card.Body>
            </Card>

            <Card className="foster-card favrhood-pillar-card favrhood-pillar-card--entrepreneurship" role="listitem">
              <Card.Body>
                <span className="favrhood-pillar-kicker">{safePillars.entrepreneurship?.kicker}</span>
                <Card.Title className="foster-card-title">{safePillars.entrepreneurship?.title}</Card.Title>
                <Card.Text className="foster-card-text">
                  {safePillars.entrepreneurship?.text}
                </Card.Text>
              </Card.Body>
            </Card>

            <Card className="foster-card favrhood-pillar-card favrhood-pillar-card--social" role="listitem">
              <Card.Body>
                <span className="favrhood-pillar-kicker">{safePillars.socialContribution?.kicker}</span>
                <Card.Title className="foster-card-title">{safePillars.socialContribution?.title}</Card.Title>
                <Card.Text className="foster-card-text">
                  {safePillars.socialContribution?.text}
                </Card.Text>
              </Card.Body>
            </Card>
          </div>

          <div className="home-inline-cta">
            <Button onClick={handleFavrhoodClick} className="custom-yellow-btn home2-cta-btn">
              {t("homeV2.favrhood.cta")}
            </Button>
          </div>

          <Row className="justify-content-center mt-4">
            <Col xs={12} sm={10} md={8} lg={6} className="text-center">
              <Tilt className="favrhood-tilt" tiltMaxAngleX={6} tiltMaxAngleY={6}>
                <img
                  src={homeImg}
                  className="img-fluid favrhood-img"
                  alt={t("home.a11y.favrhoodPreviewAlt")}
                />
              </Tilt>
            </Col>
          </Row>
        </section>

        <section className="home-block home-final-cta" aria-label={t("homeV2.a11y.finalCtaSection")}>
          <h2 className="home-block-title">{t("homeV2.finalCta.title")}</h2>
          <p className="home-block-lead">
            {t("homeV2.finalCta.lead")}
          </p>
          <div className="home-inline-cta">
            <Button as={Link} to="/courses" className="custom-yellow-btn">{t("homeV2.finalCta.primary")}</Button>
            <Button as={Link} to="/programs/partner-with-us" className="home-ghost-btn">{t("homeV2.finalCta.secondary")}</Button>
          </div>
        </section>
      </Container>
    </Container>
  );
}

export default Home2;
